"use client";

import { getQueryClient } from "@/lib/getQueryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { ReactNode } from "react";

//#region [Props]
type QueryClientWrapperProps = {
    children: ReactNode;
}
//#endregion

//#region [Component]
export default function QueryWrapper({ children }: QueryClientWrapperProps) {
    const queryClient = getQueryClient();
    return (<QueryClientProvider client={queryClient}>
        {children}
        <ReactQueryDevtools />
    </QueryClientProvider>);
}
//#endregion

//#region [Styles]

//#endregion